import { t } from "@lingui/core/macro";

export type StarterKind = "watch" | "routine" | "voice";

export type StarterTask = {
  kind: StarterKind;
  label: string;
};

/** The first-run choices; the first shows the teammate's computer working. */
export function starterTasks(): StarterTask[] {
  return [
    { kind: "watch", label: t`Watch Preá work` },
    { kind: "routine", label: t`Every day at 8am, send me the news` },
    { kind: "voice", label: t`Talk to it` },
  ];
}

/** The real task the teammate runs; it uses its computer when one is available. */
export function starterPrompt(kind: StarterKind, computer: boolean): string {
  if (kind === "routine")
    return t`Run my 8am news brief now: find the three most important news items today and send me a short summary.`;
  return computer
    ? t`Open the browser and research one current topic in tech. Save what you find in a file, then summarize it here in a few lines.`
    : t`Pick one current topic in tech and research it. Write what you find in a file, then summarize it here in a few lines.`;
}

export function starterRoutine() {
  return {
    name: t`Morning news`,
    prompt: t`Find the three most important news items today and send me a short summary.`,
    crons: ["0 8 * * *"],
  };
}


/** One nonce per teammate, so a retry, refresh or double click sends the task once. */
export const starterNonce = (botId: string) => `starter-${botId}`;

type StarterRpc = {
  routines: {
    list: (input: { botId: string }) => Promise<readonly { name: string }[]>;
    create: (input: never) => Promise<unknown>;
  };
};

/** Creates the daily routine unless the teammate already has it. */
export async function ensureStarterRoutine(rpc: StarterRpc, botId: string, timezone: string) {
  const routine = starterRoutine();
  const existing = await rpc.routines.list({ botId });
  if (existing.some((item) => item.name === routine.name)) return false;
  await (rpc.routines.create as (input: unknown) => Promise<unknown>)({
    botId,
    ...routine,
    timezone,
    active: true,
  });
  return true;
}

